module.exports = __webpack_public_path__ + "img/facebook.621d0609.svg";